import type { I18nFn } from '#/i18n/types/I18nFn';

import { LISTING_FLAGGING_REASONS } from './listingFlaggingReasons';
import { ORG_FLAGGING_REASONS } from './orgFlaggingReasons';
import { USER_FLAGGING_REASONS } from './userFlaggingReasons';

export function FLAGGING_REASONS(i18n: I18nFn) {
  return {
    ORG: ORG_FLAGGING_REASONS(i18n),
    JOB: LISTING_FLAGGING_REASONS(i18n),
    INTERNSHIP: LISTING_FLAGGING_REASONS(i18n),
    VOLOP: LISTING_FLAGGING_REASONS(i18n),
    EVENT: LISTING_FLAGGING_REASONS(i18n),
    USER: USER_FLAGGING_REASONS(i18n),
    CANDIDATE: USER_FLAGGING_REASONS(i18n),
  };
}

export type FlaggableObjectType = keyof Omit<
  ReturnType<typeof FLAGGING_REASONS>,
  'CANDIDATE'
>;
